module.exports = __webpack_public_path__ + "img/btn-bg-small.9b445685.jpg";